import { PATHS } from './config';

/**
 * Адреса карьерного раздела — ОДНО место на все экраны (ТЗ 0071).
 *
 * 🔴 Путь, собранный шаблонной строкой по месту, — это 404, невидимый для tsc,
 * сборки и тестов: переименуй параметр маршрута, и склейка в девятом файле
 * молча начнёт вести в никуда. Здесь же живёт правило, ради которого модуль
 * заведён: ссылка на навык НЕСЁТ ПРОФЕССИЮ.
 *
 * Проверка в Brave: переход из DevOps в Kubernetes открывал карту ЦЕЛИ
 * студента, а не DevOps, — `/career/skills/:slug` терял контекст, и человек
 * видел «этого навыка нет в вашей профессии» над картой, которую не открывал.
 */

/** Карта навыков: профессия и выбранный узел. Порядок ключей — как в `skillMapParams`. */
export const skillMapHref = ({
  track,
  skill,
}: {
  track?: string | null;
  skill?: string | null;
}) => {
  const search = new URLSearchParams();
  if (track) search.set('track', track);
  if (skill) search.set('skill', skill);
  const query = search.toString();
  return query ? `${PATHS.careerSkills}?${query}` : PATHS.careerSkills;
};

export const professionHref = (code: string) =>
  PATHS.careerProfession.replace(':code', encodeURIComponent(code));

export const lessonHref = (lessonId: string | number) =>
  PATHS.careerLesson.replace(':lessonId', encodeURIComponent(String(lessonId)));

/**
 * Сценарий формы отклика (0072): «уже отправил» открывает статус «Wysłana» с
 * сегодняшней датой, «планирую» — статус «Planuję» без даты.
 */
export type ApplicationScenario = 'sent' | 'planned';

/** Журнал откликов с открытой формой нужного сценария. */
export const addApplicationHref = (scenario: ApplicationScenario = 'sent') =>
  `${PATHS.careerApplications}?add=${scenario}`;

/**
 * `?add=` → сценарий. Старый `?add=1` (ссылки 0071, закладки) — это «уже
 * отправил»: так и называлась кнопка, которая его ставила.
 */
export const applicationScenarioOf = (value: string | null): ApplicationScenario | null => {
  if (value === 'planned') return 'planned';
  if (value === 'sent' || value === '1') return 'sent';
  return null;
};
